import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {NgForm} from '@angular/forms';
import {Company} from '../../types/company';
import {identityTypes} from '../../types/identity-type';
import {CompanyType} from "../../types/company-type";

@Component({
  selector: 'entity',
  templateUrl: './entity.component.html',
  styleUrls: ['./entity.component.css']
})
export class EntityComponent implements OnInit {

  @Input() company !: Company;
  @Input() companyType !: CompanyType;
  @Output() noPeselChanged = new EventEmitter<boolean>();
  @Input() pesel ?: string;
  @Output() peselChange = new EventEmitter<string>();
  @Output() registryDataInvalidChanged = new EventEmitter<boolean>();
  @Input() identityType ?: string;
  @Output() identityTypeChange = new EventEmitter<string>();
  @Input() identityValue ?: string;
  @Output() identityValueChange = new EventEmitter<string>();
  
  @ViewChild('entityForm') entityForm!: NgForm;
  noPesel : boolean = false;
  registryDataInvalid : boolean = false;
  identityTypes = identityTypes;
  CompanyType = CompanyType;

  personTypeMap : Map<CompanyType, string> = new Map([
    [ CompanyType.LEGAL, "Osoba prawna" ],
    [ CompanyType.PHYSICAL, "Osoba fizyczna" ],
    [ CompanyType.PARTNERSHIP, "Spółka nieposiadająca osobowości prawnej"]
  ]);

  constructor() { }

  ngOnInit(): void {
    this.noPesel = false;
    if (!this.company.name
      || !this.company.nip
      || !this.company.hqAddress.country
      || !this.company.hqAddress.city
      || !this.company.hqAddress.postalCode
      || !this.company.hqAddress.street
      || !this.company.hqAddress.number) {
      this.registryDataInvalid = true;
      this.registryDataInvalidChanged.emit(true);
      return;
    }

    if (this.companyType == CompanyType.PHYSICAL) {
      if (!this.company.personalData.firstname
        || !this.company.personalData.surname
        || !this.company.correspondenceAddress?.country
        || !this.company.correspondenceAddress?.city
        || !this.company.correspondenceAddress?.postalCode
        || !this.company.correspondenceAddress?.street
        || !this.company.correspondenceAddress?.number) {
        this.registryDataInvalid = true;
        this.registryDataInvalidChanged.emit(true);
        return;
      }
    } else {
      if (!this.company.krs) {
        this.registryDataInvalid = true;
        this.registryDataInvalidChanged.emit(true);
        return;
      }
    }
    this.registryDataInvalid = false;
    this.registryDataInvalidChanged.emit(false);
  }
  
  editFormInvalid() : boolean {
    if (this.registryDataInvalid)
      return true;
    if (this.entityForm == undefined)
      return false;
    if (this.noPesel) {
      let idType = this.entityForm.form.controls['idType'];
      let idNumber = this.entityForm.form.controls['idNumber'];
      if (idType != undefined 
        && idNumber != undefined 
        && ((idType.invalid && (idType.touched || idType.dirty))
        || (idNumber.invalid && (idNumber.touched || idNumber.dirty))))
          return true;
    } else {
        let pesel = this.entityForm.form.controls['pesel'];
        if (pesel != undefined && pesel.invalid && (pesel.touched || pesel.dirty))
          return true;
    }
    return false;
  }
  
  formInvalid() : boolean {
    if (this.registryDataInvalid)
      return true;
    if (this.noPesel) {
      if (this.entityForm?.form?.controls['idType']?.invalid || this.entityForm?.form?.controls['idNumber']?.invalid)
        return true;
    } else {
      if (this.entityForm?.form?.controls['pesel']?.invalid)
        return true;
    }
    return false;
  }
  
  noPeselCh(checked: boolean) : void {
    if (checked) {
      this.entityForm.form.controls['pesel'].reset();
    } else {
      this.entityForm.form.controls['idType'].reset();
      this.entityForm.form.controls['idNumber'].reset();
    }
    this.noPeselChanged.emit(checked);
  }
  
  markFormAsTouched() : void {
    this.entityForm.form.markAllAsTouched();
  }

}
